import { render, staticRenderFns } from "./ArticlesPage.vue?vue&type=template&id=327306b8&scoped=true&"
import script from "./ArticlesPage.vue?vue&type=script&lang=js&"
export * from "./ArticlesPage.vue?vue&type=script&lang=js&"
import style0 from "./ArticlesPage.vue?vue&type=style&index=0&id=327306b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327306b8",
  null
  
)

export default component.exports